<div
  class="content text-center"
  data-new-gr-c-s-check-loaded="14.1018.0"
  data-gr-ext-installed=""
>
  <div class="form-signin" (ngSubmit)="login()">
    <img
      class="mb-4"
      src="../../../assets/images/logo.png"
      alt=""
      width="72"
      height="72"
    />
    <h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>
    <label for="inputEmail" class="sr-only">Email address</label>
    <input
      type="email"
      id="inputEmail"
      class="form-control"
      placeholder="Email address"
      required
      autofocus=""
      [(ngModel)]="email"
    />
    <label for="inputPassword" class="sr-only">Password</label>
    <input
      type="password"
      id="inputPassword"
      class="form-control"
      placeholder="Password"
      required
      [(ngModel)]="password"
    />
    <!-- <div class="checkbox mb-3">
      <label> <input type="checkbox" value="remember-me" /> Remember me </label>
    </div> -->
    <button
      class="btn btn-lg btn-danger btn-block"
     (click)="login()"
      *ngIf="!loading"
    >
      Sign in
    </button>
    <ion-spinner *ngIf="loading" class="spinner"></ion-spinner>
    <p class="mt-5 mb-3 text-muted">© 2021-2022</p>
  </div>
</div>
